import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  RmBulkCommitResponse,
  RmBulkValidationResponse,
  RmOnboardRequest,
  RmOnboardResponse,
  RmOnboardingApi,
} from '../tokens/rm-onboarding.token';

/**
 * REST-only implementation of {@link RmOnboardingApi} (EM-699 / F7 — EM-712).
 *
 * Thin {@code HttpClient} wrapper over the live {@code RmOnboardingResource}
 * (EM-704 / B5) at {@code /services/embedded/api/v1/rm}. No mock, no fallback
 * (Rules 07/10); every onboarding is lender-scoped server-side (Rule 22) and rides
 * the Keycloak bearer via {@code authInterceptor}. The single home for the RM
 * onboarding endpoints — consumed by {@code features/lender-rm/channel/} through the
 * {@link RM_ONBOARDING} DI token.
 */
@Injectable()
export class RmOnboardingRestService implements RmOnboardingApi {
  private readonly http = inject(HttpClient);

  onboardSingle(request: RmOnboardRequest): Observable<RmOnboardResponse> {
    return this.http.post<RmOnboardResponse>(API_PATHS.RM_ONBOARD, request);
  }

  validateBulk(file: File): Observable<RmBulkValidationResponse> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<RmBulkValidationResponse>(`${API_PATHS.RM_ONBOARD}/bulk`, form);
  }

  commitBulk(batchId: string): Observable<RmBulkCommitResponse> {
    return this.http.post<RmBulkCommitResponse>(
      `${API_PATHS.RM_ONBOARD}/bulk/${encodeURIComponent(batchId)}/commit`,
      {},
    );
  }
}
